import * as React from 'react';
import { passwordValidationRegex } from '../../core/constants';
import Field from './Field';

const PasswordField = (props: Props) => {
	const { validate, required, ...rest } = props;
	const validatePassword = (value: string): string => {
		if (!validate || passwordValidationRegex.test(value)) {
			return null;
		}
		return 'Must contain at least 12 characters.';
	};
	// eslint-disable-next-line react/jsx-props-no-spreading
	return <Field {...rest} type="password" validate={validatePassword} required={required} />;
};

interface Props {
	label: string;
	name: string;
	value: string;
	onValueChange: (name: string, value: string | boolean, errorMessage: string) => void;
	validate?: boolean;
	validateOnMount?: boolean;
	errorMessage?: string;
	autoFocus?: boolean;
	required?: boolean;
}

PasswordField.defaultProps = {
	validate: true,
	required: true,
	validateOnMount: false,
	errorMessage: null,
	autoFocus: false
};

export default PasswordField;
